import { fetchEventDates } from "./eventDatesActions";
import { convertDateToUtc } from "../../common/helpers/dateHelpers";
import {
    getSettingsWithNoFilter,
    persistSettings,
} from "../../calendar-common/helpers/settingsHelper";
import { getViewDefaultSettings } from "../helpers";

export const changeTimezone = (store, offset, timezone) => {
    const { settings, defaultSettings, currentTime } = store.getState();

    if (offset === null) offset = defaultSettings.timezoneOffset;

    if (settings.timezoneOffset === offset) return;

    var time = convertDateToUtc(currentTime, offset);

    store.setState({
        settings: {
            ...settings,
            timezoneOffset: offset,
        },
        currentTimezone: timezone,
        currentTime: time,
    });
};

export const changeTimezoneAndFetch = (store, timezone) => {
    changeTimezone(store, timezone.OffsetValue, timezone);
    fetchEventDates(store);

    const { config } = store.getState();
    if (config.timezoneHelper) {
        config.timezoneHelper().then((helper) => {
            helper.setTimezone(timezone);
        });
    }
};

export const updateSettingsFromStorage = (store) => {
    let storageSettings = getSettingsWithNoFilter();
    const { settings } = store.getState();

    let newSettings = { ...settings, ...storageSettings };
    store.setState({ settings: newSettings });

    if (settings.view === newSettings.view) return;

    newSettings = getViewDefaultSettings(store.getState());
    store.setState({ settings: newSettings });
    fetchEventDates(store);
    return newSettings;
};

export const changeSettingsAndSave = (store, newSettings) => {
    const { settings } = store.getState();
    let actualSettings = { ...settings, ...newSettings };
    store.setState({ settings: actualSettings });
    persistSettings(newSettings);

    if (newSettings.view != undefined && settings.view !== newSettings.view) {
        actualSettings = getViewDefaultSettings(store.getState());
        store.setState({ settings: actualSettings });
        persistSettings({actualFilterType: actualSettings.actualFilterType });
        fetchEventDates(store);
    }
};
